import { integer, required } from "vuelidate/lib/validators";

export default class MesaData {
  id = null;
  ambiente_id = null;
  numero = "";
  numero_inicial = null;
  numero_final = null;
  nome = "";
  descricao = "";
  capacidade = null;
  status = "livre";
  ativo = true;

  constructor({
    id = null,
    ambiente_id = null,
    numero = "",
    numero_inicial = null,
    numero_final = null,
    nome = "",
    descricao = "",
    capacidade = null,
    status = "livre",
    ativo = true,
  } = {}) {
    this.id = id;
    this.ambiente_id = ambiente_id;
    this.numero = numero;
    this.numero_inicial = numero_inicial;
    this.numero_final = numero_final;
    this.nome = nome || "";
    this.descricao = descricao || "";
    this.capacidade = capacidade;
    this.status = status || "livre";
    this.ativo = ativo;
  }
}

const numeroFinalMaiorOuIgualInicial = (value, form) => {
  if (value === null || value === undefined || value === "") {
    return true;
  }

  if (
    form.numero_inicial === null ||
    form.numero_inicial === undefined ||
    form.numero_inicial === ""
  ) {
    return true;
  }

  return Number(value) >= Number(form.numero_inicial);
};

const MesaDataBaseRequired = {
  ambiente_id: {
    required,
  },
  capacidade: {
    integer,
  },
  status: {
    required,
  },
};

export const MesaDataCreateRequired = {
  ...MesaDataBaseRequired,
  numero: {},
  numero_inicial: {
    required,
    integer,
  },
  numero_final: {
    required,
    integer,
    numeroFinalMaiorOuIgualInicial,
  },
};

export const MesaDataUpdateRequired = {
  ...MesaDataBaseRequired,
  numero: {
    required,
  },
  numero_inicial: {},
  numero_final: {},
};
